import template from './ticketTableHeader.html';
import { TicketTableHeaderController } from './ticketTableHeader.controller';

export const ticketTableHeaderComponent = {
  restrict: 'E',
  template,
  controller: TicketTableHeaderController,
  controllerAs: 'vm',
  bindings: {
    ticketType: '@',
    ibans: '<',
    onChange: '&',
    createNew: '&',
    onDownloadProgression: '&',
    onDownloadBafin: '&',
    excludedFilters: '<',
    externalSearchTerm: '='
  }
};
